var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "text",
    style: {
      color: _vm.textColor
    },
    attrs: {
      "color": _vm.textColor
    }
  }, [_vm._v(_vm._s(_vm.text))]), _c('div', {
    staticClass: "icon",
    style: {
      'background-color': _vm.iconColor
    }
  }, [_c('Icon', {
    attrs: {
      "color": "white",
      "type": _vm.iconType,
      "size": "12"
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }